// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.default-broker-form-section {
  display: flex;
  flex-direction: column;
}
.default-broker-form-section .items {
  display: flex;
  flex-wrap: wrap;
  max-height: 500px;
  overflow-y: auto;
}
.default-broker-form-section .items > div {
  font-size: 12px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  margin-bottom: 10px;
  background: #FFFFFF;
  border: 1px solid rgba(129, 159, 188, 0.15);
  border-radius: 10px;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
}
.default-broker-form-section .items > div .details {
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: space-between;
}
.default-broker-form-section .items > div .details > div {
  display: flex;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
}
.default-broker-form-section .items > div .details > div img {
  border: 3px solid #F4F5F6;
  border-radius: 10px;
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.default-broker-form-section .items > div .details > div .set {
  cursor: pointer;
  color: var(--secondary-color-5);
  font-weight: 700;
  transition: 0.3s ease-in-out;
}
.default-broker-form-section .items > div .details > div .set:hover {
  color: var(--primary-color-1);
}
.default-broker-form-section .items > div .details > div .current {
  color: var(--primary-color-1);
  font-weight: 700;
}
.default-broker-form-section .items > div .details > div .info {
  margin-left: 25px;
}
.default-broker-form-section .items > div .details > div .info > p {
  margin: 0;
}
.default-broker-form-section .items > div .details > div .info .name {
  font-weight: 700;
  font-size: 16px;
  color: var(--secondary-color-1);
}
.default-broker-form-section .items > div .details > div .info .email {
  font-weight: 600;
  font-size: 12px;
  color: #6C767C;
}`, "",{"version":3,"sources":["webpack://./src/routes/BeeTier/modules/DefaultBrokerModal/defaultBrokerModal.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;AAAI;EACI,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAER;AADQ;EACI,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;AAGZ;AAFY;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAIhB;AAHgB;EACI,aAAA;EACA,mBAAA;EACA,uCAAA;AAKpB;AAJoB;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAMxB;AAJoB;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,4BAAA;AAMxB;AALwB;EACI,6BAAA;AAO5B;AAJoB;EACI,6BAAA;EACA,gBAAA;AAMxB;AAJoB;EACI,iBAAA;AAMxB;AALwB;EAAM,SAAA;AAQ9B;AAPwB;EACI,gBAAA;EACA,eAAA;EACA,+BAAA;AAS5B;AAPwB;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAS5B","sourcesContent":[".default-broker-form-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    .items {\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        max-height: 500px;\r\n        overflow-y: auto;\r\n        > div {\r\n            font-size: 12px;\r\n            font-weight: 500;\r\n            font-family: 'Roboto', sans-serif;\r\n            margin-bottom: 10px;\r\n            background: #FFFFFF;\r\n            border: 1px solid rgba(129, 159, 188, 0.15);\r\n            border-radius: 10px;\r\n            width: 100%;\r\n            height: fit-content;\r\n            .details {\r\n                display: flex;\r\n                padding: 20px;\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                > div {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    font-family: 'Proxima Nova', sans-serif;\r\n                    img {\r\n                        border: 3px solid #F4F5F6;\r\n                        border-radius: 10px;\r\n                        width: 40px;\r\n                        height: 40px;\r\n                        object-fit: cover;\r\n                    }\r\n                    .set {\r\n                        cursor: pointer;\r\n                        color: var(--secondary-color-5);\r\n                        font-weight: 700;\r\n                        transition: .3s ease-in-out;\r\n                        &:hover {\r\n                            color: var(--primary-color-1);\r\n                        }\r\n                    }\r\n                    .current {\r\n                        color: var(--primary-color-1);\r\n                        font-weight: 700;\r\n                    }\r\n                    .info {\r\n                        margin-left: 25px;\r\n                        > p { margin: 0; }\r\n                        .name {\r\n                            font-weight: 700;\r\n                            font-size: 16px;\r\n                            color: var(--secondary-color-1);\r\n                        }\r\n                        .email {\r\n                            font-weight: 600;\r\n                            font-size: 12px;\r\n                            color: #6C767C;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
